import React from "react";

export default function Footer() {
  return (
    <div>
      <footer class="font-bold text-center lg:text-left bg-gray-50 border shadow-sm">
        <div className="text-gray-900 text-center p-4 bg-gray-50">
          © 2022 Copyright : Hekar A. Mohammed
        </div>
      </footer>
    </div>
  );
}
